/** @jsx jsx */
import { jsx } from "theme-ui"
import Layout from "../../components/layout"
import IconText from "./IconText"

export default function SecondaryNav() {
    return(
        <div sx={{
            bg: 'secondaryColor',
            width: '100%',
            color: 'white'
        }}>
            <Layout variant="wide">
                <div sx={{
                    display: 'flex',
                    height: '2rem',
                    px: [3,3,0],
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div sx={{display: ['none', 'none', 'inline']}}>
                        <IconText variant="hours" isOpen />
                    </div>
                    <div sx={{display: 'flex'}}>
                        <span><IconText variant="directions" text="28 Waverly PI, San Francisco, CA 94108"/></span>
                        <span sx={{display: ['none', 'none', 'flex'], '> *':{ml: 3}}}><IconText variant="phone" text="(123) 456 7890" /></span>
                    </div>
                </div>
            </Layout>
        </div>
    )
}